// @flow

import React, { useState, useEffect, useCallback } from "react";
import Link from "../../Link";
import { Location, Icon } from "@2po-c21/components";
import { findNearbyPlaces } from "@utils/mapbox";
import { t } from "ttag";
import style from "./style.module.scss";

import { createContentfulRenderer, CONTENTFUL_TYPES } from "../types";

type Props = {
    id: string,
    findNearbyLabel?: string,
    places: {
        id: string,
        pageTitle?: string,
        slug: string,
    }[],
    postalCode?: string,
};

const render = (
    { findNearbyLabel, places, postalCode }: Props,
    _,
    locale: string,
) => {
    const [towns, setTowns] = useState([]);

    const fetchNearbyPlacesCallback = useCallback(
        async (postalCode, locale) => {
            const nearbyPlaces = await findNearbyPlaces(postalCode, locale);
            setTowns(nearbyPlaces);
        },
        [postalCode, locale],
    );

    useEffect(() => {
        if (postalCode) {
            fetchNearbyPlacesCallback(postalCode, locale);
        }
    }, [postalCode, fetchNearbyPlacesCallback, locale]);

    return (
        <>
            {places?.length > 0 && (
                <div className={style.container}>
                    <Icon icon={Location} size={"md"} />
                    {findNearbyLabel}
                    <ul className={style.placesList}>
                        {places.map((item, index) => (
                            <li className={style.link} key={index}>
                                <Link to={item?.slug}>{item?.pageTitle}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {towns.length > 0 && (
                <div className={style.container}>
                    <Icon icon={Location} size={"md"} />
                    {findNearbyLabel}
                    <ul className={style.placesList}>
                        {towns.map((town, index) => (
                            <li className={style.link} key={index}>
                                <Link
                                    to={`/${
                                        window.location.pathname.split("/")[1]
                                    }/${t`search`}?${town.postalcodes
                                        .map((code) => `location=${code}`)
                                        .join("&")}`}
                                >
                                    {town.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </>
    );
};

const condition = (content) =>
    content.__typename === CONTENTFUL_TYPES.NearbyPlaces;

export default createContentfulRenderer(condition, render);
